import { query as apiQuery } from '~/api/tiles';

export async function query(layerId: string, bounds: number[][], z: number) {
  const data = await apiQuery(layerId, bounds.flat() as [number, number, number, number], z);

  return data;
}
